import { OptionalPaginationQueryParams, Pagination } from "@CommonTypes/backend/pagination";
import { OneStoreViewRow } from "@CommonTypes/merchflow/OneStoreView";

export const RouteGetMerchflows_merchflowId_StoresAll = "/merchflows/:merchflowId/stores/all";

export type AllStoresSortableColumn =
  "id" | "process_order" | "returnOnSpace" | "coreRange" | "shelfAlignment" | "dosMos" | "size";

export type ParamsGetMerchflows_merchflowId_StoresAll = OptionalPaginationQueryParams & {
  store_pog_trigger_id?: number;
  storeCode?: string;
  sortBy?: AllStoresSortableColumn;
  sortDirection?: "asc" | "desc";
  viewMode?: "list" | "grid";
};

export type ResponseGetMerchflows_merchflowId_StoresAll = Pagination<OneStoreViewRow> & {
  project_id: number | null;
};
